/* eslint-disable import/extensions */
import { exists } from '@treasury/utils';
import { LEGACY_BO_API_ROOT, LEGACY_CHANNEL_API_ROOT } from '../config/api-paths';
import { ConfigurationService, boApiRoot, channelApiRoot } from '../config/configuration.service';

export const AUTH_TOKEN = 'Jha-Treasury-JhaAuthToken';

let channelApiPathOverride;

export const getAuthToken = () => window.sessionStorage.getItem(AUTH_TOKEN);
export const removeAuthToken = () => window.sessionStorage.removeItem(AUTH_TOKEN);

/**
 * @param {string} [token]
 */
export const updateAuthToken = token => {
    if (!exists(token) || token === '') {
        removeAuthToken();
        return;
    }

    window.sessionStorage.setItem(AUTH_TOKEN, token);
};

/**
 * Determine if the request to the provided URL is an API request and requires an authentication token.
 * @param {string } url
 */
export async function isApiRequest(url) {
    const { apiRoot } = await ConfigurationService.getInstance();
    return (
        url.includes(apiRoot) ||
        // the following two checks are included for legacy behavior
        // but should not be necessary while using injected API URLs
        url.includes(LEGACY_BO_API_ROOT) ||
        url.includes(LEGACY_CHANNEL_API_ROOT)
    );
}

/**
 * Allows runtime override of the legacy Channel API path.
 * This is needed for FI-specific API roots discovered after app bootstrap.
 * @param {string | undefined} path
 */
export const setChannelAPIPathOverride = path => {
    channelApiPathOverride = path;
};

export const clearChannelAPIPathOverride = () => {
    channelApiPathOverride = undefined;
};

export const getChannelAPIPath = () => `${channelApiPathOverride ?? channelApiRoot}/`;
export const getBackOfficeAPIPath = () => `${boApiRoot}/`;
